// Copyright ©️ 2025 eVolve MEP, LLC

export const withHttp = (url = '') => (url.indexOf('://') === -1 ? `http://${url}` : url);
